import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from '@chakra-ui/react';
import { CalendarButton } from './components/CalendarButton';
import { DateRangePickerCalendar } from './components/DateRangePickerCalendar';
import { DateRangePickerContent } from './components/DateRangePickerContent';
import { DateRangePickerWrapper } from './components/DateRangePickerWrapper';
import { DateRangePickerProvider } from './DateRangePickerContext';
export const DateRangePicker = forwardRef((props, ref) => {
    return (_jsx(DateRangePickerProvider, { ...props, children: _jsxs(DateRangePickerWrapper, { ref: ref, children: [_jsx(CalendarButton, {}), _jsx(DateRangePickerContent, { children: _jsx(DateRangePickerCalendar, {}) })] }) }));
});
DateRangePicker.displayName = 'DateRangePicker';
